const pollActions = {
  subscribePollUpdateAction: ({ dispatch }, { slide }) => {
    if (!slide || !slide.id) return
    dispatch('subscribeCountingForSlideAction', { slide })
  },

  unsubscribePollUpdateAction: ({ dispatch }, { slide }) => {
    if (!slide?.id) return
    dispatch('unsubscribeCountingForSlideAction', { slide })
  },
}

export default pollActions
